module.exports = __webpack_public_path__ + "assets/img/aboutUS-module4-3.a06cd83c.jpg";